import { SvgIconProp } from '../models/dynamic.model';
import {
  DEFAULT_RPE_ICON_ACTION_MAP,
  RPE_NON_ACTION_ICON_NAMES,
} from './rpe-action.constants';

export interface ApplyRpeActionPermissionsOptions {
  /** Overrides / extends {@link DEFAULT_RPE_ICON_ACTION_MAP} (e.g. edit→bulk edit when multi-select). */
  iconActionOverrides?: Record<string, string>;
  /**
   * When true, icons with no RPE action mapping are hidden (except {@link RPE_NON_ACTION_ICON_NAMES}).
   * Default false — workflow icons not yet in Roles & Permissions config stay visible (D-RPE-UI).
   */
  hideUnmapped?: boolean;
}

export function applyActionPermissionsToIcons(
  icons: SvgIconProp[],
  hasAction: (actionName: string) => boolean,
  options: ApplyRpeActionPermissionsOptions = {}
): SvgIconProp[] {
  const { iconActionOverrides = {}, hideUnmapped = false } = options;
  const iconActionMap = {
    ...DEFAULT_RPE_ICON_ACTION_MAP,
    ...iconActionOverrides,
  };

  return icons.filter((icon) => {
    const apiAction = iconActionMap[icon.name];
    if (!apiAction) {
      if (!hideUnmapped || RPE_NON_ACTION_ICON_NAMES.has(icon.name)) {
        return true;
      }
      return false;
    }
    return hasAction(apiAction);
  });
}
